const faqs = [
	{
		question: "What SDC aims to?",
		answer: "We aim at lending a helping hand to all the beginners in the world of programming",
	},
	{
		question: "What kinds of events does the club host?",
		answer: "We have number of events to provide students a platform to compete against the best of minds . Our other events include short and long challenges , technical fests and hackathons.",
	},
	{
		question: "Why should I join this tech community?",
		answer: "Our main objective is to encourage open source software , improving coding culture , project building and introducing new platforms to work on. It provides opportunities for students to broaden their knowledge in the field of computer science and interact with other students who have shared interests",
	},
	{
		question: "How can I transition to a great tech career at SDC?",
		answer: "You can have a great tech career at SDC by working with experienced members of the club. You will do projects in teams and leading events which enhance your skills.",
	},
	{
		question: "What kind of roles do we do in this club?",
		answer: (
			<ul>
				<li> Tech Team </li>
				<li>Design Team</li>
				<li>Social Media Team</li>
				<li>Content Team</li>
				<li>Media Team</li>
			</ul>
		),
	},
	{
		question: "Does SDC conduct workshops?",
		answer: "Yes we do conduct workshops based on different domains.",
	},
	{
		question: "Does the SDC organize events?",
		answer: "Yes, SDC conducts various events ",
	},
	{
		question: "Does the SDC organize non-tech events?",
		answer: "Yes, SDC conduct such events like Gaming Tournaments.",
	},
];

export default faqs;
